module.exports = __webpack_public_path__ + "img/Capt2ure2.741e242c.jpg";